// Resolve a team selection to the set of team ids it covers: the team itself
// plus all descendant teams. Uses the organization1level map (team_id ->
// {descendantId: ...}) when present, and walks team parent chains as a
// fallback — the organization1level collection is not maintained for every
// company, and without the walk a parent team resolves to only its direct
// members.
export function resolveTeamScope(teamId: string, orgMap: any, teams: any) {
    const scope: any = { [teamId]: true }
    if (orgMap && orgMap[teamId]) {
        for (const id in orgMap[teamId]) {
            scope[id] = true
        }
    }
    for (const id in teams || {}) {
        let current = id
        let depth = 0
        while (current && depth < 20) {
            if (scope[current]) {
                scope[id] = true
                break
            }
            current = teams[current] ? teams[current].parent : null
            depth++
        }
    }
    return scope
}
